/* istanbul ignore next */
export function downloadFromBlob(blob: Blob, filename: string) {
  const data = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = data;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(data);
}
